import React from 'react';

export default class CollapsiblePanelWrapper extends React.Component
{
	constructor(props) 
	{
		super(props);

		this.state = {
			title: this.props.title,
			forceOpen: false ,
			mode: 'all_options',
			buttonState: ''
		};
	}

	panelContent()
	{
		return this.props.children ;
	}

	collapsiblePanelBody( id )
	{
		if ( this.state.forceOpen == true )
		{
		    return React.createElement ( 'div', { key: 'PanelCollapseDiv', id: id, className: 'panel-collapse collapse in'},
		    		React.createElement ( 'div', { key: 'PanelCollapsBodyDiv', className: 'panel-body'}, this.panelContent())) ;
		
		}
		else
		{
		    return React.createElement ( 'div', { key: 'PanelCollapseDiv', id: id, className: 'panel-collapse collapse'},
		    		React.createElement ( 'div', { key: 'PanelCollapsBodyDiv', className: 'panel-body'}, this.panelContent())) ;
		}
		
	}


	collapsiblePanelHeading ( id, title )
	{
		const headingStyle =  { paddingTop: '10px', paddingBottom: '10px', color: '#69a1d2', margin: '10px' } ;

	    return React.createElement ( 'div', { key: 'PanelCollapseHeadingDiv', className: 'panel-heading', style: headingStyle },
	    		React.createElement ( 'h4', { key: 'PanelCollapseTitleDiv', className: 'panel-title panel-dropdown' },
	    				React.createElement ( 'a', { 
	    				onClick: this.onCollapseClick,
							key: 'PanelCollapseAnchor',
	    				'data-toggle' : 'collapse', 
	    				href: '#'+id}, title))) ;
	}

	collapsiblePanelHeadingAndContent()
	{
		let lineList = [] ;
		
		lineList.push ( this.collapsiblePanelHeading ( this.props.id, this.state.title)) ;
		lineList.push ( this.collapsiblePanelBody ( this.props.id )) ;
		
		return lineList ;
	}

    render() 
    {
		return React.createElement ( 'div', { key: 'PanelCollapseGroupDiv', className: 'panel-group', style: { marginTop: '15px', marginBottom: '0px'}},
			React.createElement ( 'div', { key: 'PanelCollapsPanelDiv', className: 'panel panel-default' }, this.collapsiblePanelHeadingAndContent())) ;
    }
};


